import { createIcon } from '@chakra-ui/react/icon'

const WarningIcon = createIcon({
  displayName: 'WarningIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      d="M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.88147 4.14491C8.96848 4.31893 9.00204 4.51482 8.97791 4.70788L8.49614 8.56202C8.46486 8.81223 8.25216 9 8 9C7.74784 9 7.53514 8.81223 7.50386 8.56202L7.02209 4.70788C6.99796 4.51482 7.03152 4.31893 7.11853 4.14491C7.48171 3.41854 8.51829 3.41854 8.88147 4.14491ZM8 12C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z"
      fill="#D82A13"
    />,
  ],
})

export default WarningIcon
